import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ClipboardCheck, PhoneCall, CheckCircle2 } from "lucide-react";

export default function TasksPanel() {
  const [mine, setMine] = useState([]);
  const [given, setGiven] = useState([]);
  const [tab, setTab] = useState("mine");

  const load = async () => {
    try {
      const [a, b] = await Promise.all([
        api.get("/tasks", { params: { scope: "mine" } }),
        api.get("/tasks", { params: { scope: "given" } }),
      ]);
      setMine(a.data);
      setGiven(b.data);
    } catch { /* ignore */ }
  };
  useEffect(() => { load(); }, []);

  const complete = async (id) => {
    await api.patch(`/tasks/${id}`, { status: "done" });
    load();
  };

  const list = tab === "mine" ? mine : given;
  if (mine.length === 0 && given.length === 0) return null;

  return (
    <Card className="p-4 border border-border" data-testid="tasks-panel">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
        <p className="font-display font-semibold text-sm flex items-center gap-2">
          <ClipboardCheck className="h-4 w-4 text-cyan-500" /> Arama Görevleri
        </p>
        <div className="inline-flex rounded-lg border border-border bg-muted p-0.5">
          {[["mine", `Bana Atanan (${mine.filter((t) => t.status === "open").length})`],
            ["given", `Atadığım (${given.filter((t) => t.status === "open").length})`]].map(([k, l]) => (
            <button key={k} onClick={() => setTab(k)} data-testid={`tasks-tab-${k}`}
              className={`px-2.5 py-1 text-xs font-medium rounded-md transition-colors ${tab === k ? "bg-card text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"}`}>{l}</button>
          ))}
        </div>
      </div>
      {list.length === 0 ? (
        <p className="text-xs text-muted-foreground" data-testid="tasks-empty">Bu listede görev yok.</p>
      ) : (
        <div className="space-y-1.5 max-h-64 overflow-y-auto">
          {list.map((t) => (
            <div key={t.id} className="flex items-center gap-2 py-1.5 border-b border-border/40 last:border-0" data-testid={`task-row-${t.id}`}>
              {t.status === "done"
                ? <CheckCircle2 className="h-4 w-4 text-emerald-500 shrink-0" />
                : <PhoneCall className={`h-4 w-4 shrink-0 ${t.overdue ? "text-red-500" : "text-amber-500"}`} />}
              <div className="min-w-0 flex-1">
                <p className={`text-sm truncate ${t.status === "done" ? "line-through text-muted-foreground" : t.overdue ? "font-semibold text-red-600" : "font-medium"}`}>
                  {t.overdue ? "⚠ " : ""}{t.voter_name}
                </p>
                <p className={`text-[11px] truncate ${t.overdue ? "text-red-500" : "text-muted-foreground"}`}>
                  {tab === "mine" ? `Atayan: ${t.assigner_name}` : `Sorumlu: ${t.assignee_name}`}
                  {t.note ? ` · ${t.note}` : ""}
                  {t.overdue ? " · 24 saati aştı" : ""}
                </p>
              </div>
              {t.status === "open" && (
                <Button size="sm" variant="outline" className="h-7 text-[11px] px-2" onClick={() => complete(t.id)} data-testid={`task-done-${t.id}`}>
                  Tamamlandı
                </Button>
              )}
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
